var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"reserve flex-row align-center justify-center"},[_vm._v("© 2023 movietvshow.online All Right Reserved")])
}
var staticRenderFns = []

export { render, staticRenderFns }